/* eslint-disable arrow-body-style */
/* eslint-disable eqeqeq */
import tinycolor from 'tinycolor2';

const getRgbString = (rgb: tinycolor.ColorFormats.RGBA) => `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`;

export const getRgbRaw = (rgb: tinycolor.ColorFormats.RGBA) => `${rgb.r}, ${rgb.g}, ${rgb.b}`;

export const colorToRGBValue = (str: string, fallback: string) => {
  const parsed = tinycolor(str);

  if (!parsed.isValid()) {
    return fallback;
  }

  const rgb = parsed.toRgb();

  return getRgbString(rgb);
};

type GenericObject<T = any> = Record<string, T>;

function _mergeKeepShapeObject(target: GenericObject, source: GenericObject) {
  const ret: GenericObject = {};
  Object.keys(target).forEach((key) => {
    const sourceValue = source[key];
    if (typeof sourceValue !== 'undefined') {
      ret[key] = _mergeKeepShape(target[key], sourceValue);
    } else {
      ret[key] = target[key];
    }
  });
  return ret;
}

const isArray = (x: unknown): x is Array<unknown> => {
  return Array.isArray(x);
};

const isObject = (x: unknown): x is GenericObject => {
  return typeof x === 'object' && x !== null;
};

function _mergeKeepShape(target: any, source: any) {
  if (target === null || source === null) {
    return target;
  }

  // Don't support arrays
  if (isArray(source)) {
    return target;
  }

  if (isObject(target)) {
    // If target is object and source is not -> shape fallback to target
    if (!isObject(source)) {
      return target;
    }

    return _mergeKeepShapeObject(target, source);
  }

  return source;
}

export const mergeKeepShape = <T extends GenericObject, R extends GenericObject>
  (target: T, source: R): T => {
  return _mergeKeepShape(target, source);
};

export const THEME_SIZES = {
  footerSize: '--sizes-footer-size',
} as const;

export const getSizeVarAsInt = (name: typeof THEME_SIZES[keyof typeof THEME_SIZES]) => {
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(name);

  return parseInt(value, 10);
};
